// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__7c6wd","toggle":"styles_toggle__3nXsB","preview":"styles_preview__3WR3s"};